module.exports = __webpack_public_path__ + "img/garage-door-styles.710a1cd6.jpg";